import React from 'react';
import { Avatar, Box, Button, Divider, Stack, Typography } from '@mui/material';
import moment from 'moment';

export default function UserDetailPaymentAdmin({ userDetail, onClose }) {
  // Function to mask the card number
  const maskCardNumber = (cardNo) => {
    if (!cardNo) return 'N/A';
    return `${cardNo.slice(0, 4)}-****-****-${cardNo.slice(-4)}`;
  };

  return (
    <Box p={3} pb={5} width={'100%'}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar alt={userDetail?.name} src={userDetail?.avatar} sx={{ width: 64, height: 64 }} />
          <Box>
            <Typography variant="h6">{userDetail?.name || 'N/A'}</Typography>
            <Typography variant="body2" color="textSecondary">
              Email: {userDetail?.email || 'N/A'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Contact: {userDetail?.contact_no || 'N/A'}
            </Typography>
          </Box>
        </Stack>

        <Divider />

        <Stack spacing={2}>
          <Box>
            <Typography variant="h6" component="div">
              Role:
            </Typography>
            <Typography>{userDetail?.role?.role_name || 'N/A'}</Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" component="div">
              Status:
            </Typography>
            <Typography style={{ textTransform: 'capitalize' }}>
              {userDetail?.status || 'N/A'}
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" component="div">
              Location:
            </Typography>
            <Typography>{userDetail?.location || 'N/A'}</Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" component="div">
              Payment Method:
            </Typography>
            <Typography style={{ textTransform: 'capitalize' }}>
              {userDetail?.payment_method || 'N/A'}
            </Typography>
          </Box>

          <Divider />
          <Box>
            <Typography variant="h6" component="div">
              Default Bank:
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Bank Name: {userDetail?.default_bank?.bank_name || 'N/A'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Branch Name: {userDetail?.default_bank?.branch_name || 'N/A'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Account Number: {maskCardNumber(userDetail?.default_bank?.account_no) || 'N/A'}
            </Typography>
          </Box>

          {userDetail?.payment_method?.toLowerCase() === 'card' && (
            <>
              <Divider />
              <Box>
                <Typography variant="h6" component="div">
                  Default Card:
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Card Number: {maskCardNumber(userDetail?.default_card?.card_no)}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Card Holder: {userDetail?.default_card?.card_holder_name || 'N/A'}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Expiry Date: {moment(userDetail?.default_card?.expire_date).format('DD/YY') || 'N/A'}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Card Type: {userDetail?.default_card?.card_type || 'N/A'}
                </Typography>
              </Box>
            </>
          )}

          <Divider />

          <Box>
            <Typography variant="h6" component="div">
              Total Orders:
            </Typography>
            <Typography>{userDetail?.count?.total_orders_count || 0}</Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" component="div">
              Completed Orders:
            </Typography>
            <Typography>{userDetail?.count?.total_completed_orders_count || 0}</Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" component="div">
              Cancelled Orders:
            </Typography>
            <Typography>{userDetail?.count?.total_cancelled_orders_count || 0}</Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" component="div">
              Refunded Orders:
            </Typography>
            <Typography>{userDetail?.count?.total_refunded_orders_count || 0}</Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h6" component="div">
              Total Earning:
            </Typography>
            <Typography>{userDetail?.count?.total_earning_orders_count || 0}</Typography>
          </Box>
        </Stack>

        <Divider />
      </Stack>
      <Box display="flex" justifyContent="flex-end" pb={2} pt={2}>
        <Button color="primary" variant="contained" onClick={onClose} size="small">
          Close
        </Button>
      </Box>
    </Box>
  );
}
